/* Circle : tailles des filtres triées (vêtements, tailles chiffrées, puis pointures par taille européenne) au lieu de l'ordre alphabétique */
(function () {
  var ORDRE = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl', 'xxxl'];
  var NOM = 'filter.v.option.taille';

  function cle(t) {
    t = t.trim().toLowerCase();
    var m = t.match(/^(\d+(?:\.\d+)?)\s*us\s*\/?\s*(\d+)(?:\.(\d+))?(?:\s+(\d)\/(\d))?/);
    if (m) {
      var eu = parseFloat(m[2] + (m[3] ? '.' + m[3] : '')) + (m[4] ? m[4] / m[5] : 0);
      return [2, eu, parseFloat(m[1]), t];
    }
    m = t.match(/^(xxs|xs|s|m|l|xl|xxl|xxxl)(?:\s*-\s*(xxs|xs|s|m|l|xl|xxl|xxxl))?\b/);
    if (m) {
      var a = ORDRE.indexOf(m[1]), b = m[2] ? ORDRE.indexOf(m[2]) : a;
      return [0, (a + b) / 2, 0, t];
    }
    m = t.match(/^(\d+(?:\.\d+)?)$/);
    if (m) return [1, parseFloat(m[1]), 0, t];
    return [3, 0, 0, t];
  }

  function comparer(a, b) {
    for (var i = 0; i < 3; i++) if (a[i] !== b[i]) return a[i] - b[i];
    return a[3] < b[3] ? -1 : a[3] > b[3] ? 1 : 0;
  }

  function trier() {
    var listes = [];
    document.querySelectorAll('input[name="' + NOM + '"]').forEach(function (input) {
      var li = input.closest('li');
      if (li && li.parentElement && listes.indexOf(li.parentElement) < 0) listes.push(li.parentElement);
    });
    listes.forEach(function (liste) {
      var items = Array.prototype.filter.call(liste.children, function (li) {
        return li.querySelector('input[name="' + NOM + '"]');
      });
      var tries = items.slice().sort(function (a, b) {
        return comparer(cle(a.querySelector('input').value), cle(b.querySelector('input').value));
      });
      if (tries.every(function (li, k) { return li === items[k]; })) return;
      tries.forEach(function (li) { liste.appendChild(li); });
    });
  }

  // Choisir une taille coche aussi « En stock » : sinon Shopify montre les produits dont cette taille est épuisée
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.name !== NOM || !t.checked) return;
    var form = t.closest('form');
    var dispo = form && form.querySelector('input[name="filter.v.availability"][value="1"]');
    if (dispo && !dispo.checked && !dispo.disabled) dispo.checked = true;
  }, true);

  // Écran tactile : toucher la photo d'une carte produit ouvre la fiche. Sans ça, le carrousel de photos captait le doigt
  // et l'effet « 2e photo au survol » demandait deux touchers sur iPhone. Un glissement fait toujours défiler les photos.
  // Selon le téléphone, le doigt arrive en événements « touch », « pointer » ou seulement en « click » : on écoute les trois.
  var PHOTO = '.card-wrapper .card__inner .media, .card-wrapper .card__media';
  var tactile = window.matchMedia('(hover: none)').matches || navigator.maxTouchPoints > 0;
  var depart = null, parti = false;
  function photo(cible) { return cible && cible.closest ? cible.closest(PHOTO) : null; }
  function ouvrir(media, e) {
    var carte = media.closest('.card-wrapper');
    var lien = carte && carte.querySelector('a.js-color-swatches-link[href], .card__heading a[href], a[href*="/products/"]');
    if (!lien || parti) return;
    parti = true;
    if (e && e.cancelable) e.preventDefault();
    window.location.href = lien.href;
  }
  function debut(x, y, media) { depart = media ? { x: x, y: y, t: Date.now(), media: media } : null; }
  function fin(x, y, e) {
    if (!depart) return;
    var d = depart;
    depart = null;
    if (Math.abs(x - d.x) > 12 || Math.abs(y - d.y) > 12 || Date.now() - d.t > 700) return; // glissement ou appui long
    ouvrir(d.media, e);
  }
  document.addEventListener('touchstart', function (e) {
    if (e.touches.length === 1) debut(e.touches[0].clientX, e.touches[0].clientY, photo(e.target)); else depart = null;
  }, { passive: true, capture: true });
  document.addEventListener('touchend', function (e) {
    var p = e.changedTouches[0];
    fin(p.clientX, p.clientY, e);
  }, { passive: false, capture: true });
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType !== 'mouse') debut(e.clientX, e.clientY, photo(e.target));
  }, { passive: true, capture: true });
  document.addEventListener('pointerup', function (e) {
    if (e.pointerType !== 'mouse') fin(e.clientX, e.clientY, e);
  }, { capture: true });
  document.addEventListener('click', function (e) {
    var m = tactile && photo(e.target);
    if (m && !e.target.closest('a[href], button')) ouvrir(m, e); // dernier recours si le téléphone n'envoie qu'un clic
  }, true);
  window.addEventListener('pageshow', function () { parti = false; depart = null; }); // retour arrière : on repart à zéro

  var attente;
  function plusTard() {
    clearTimeout(attente);
    attente = setTimeout(trier, 50);
  }
  document.addEventListener('DOMContentLoaded', function () {
    trier();
    // les filtres sont redessinés à chaque clic (sans recharger la page) : on retrie après chaque mise à jour
    new MutationObserver(plusTard).observe(document.body, { childList: true, subtree: true });
  });
})();
